<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#29B5E8" fill-rule="nonzero">
        <g>
          <path
            d="M27.1 24.48l-6.674-3.855c-.937-.54-2.136-.219-2.679.719-.21.37-.292.775-.253 1.17v7.534c0 1.077.875 1.952 1.955 1.952 1.077 0 1.952-.875 1.952-1.952v-4.332l3.738 2.159c.938.543 2.14.219 2.68-.719.542-.937.22-2.136-.72-2.676M10.503 16.219c.011-.696-.355-1.344-.958-1.693l-6.673-3.853c-.29-.167-.622-.255-.954-.255-.685 0-1.321.366-1.662.957-.529.915-.213 2.088.701 2.616l3.847 2.22-3.847 2.22c-.443.256-.761.668-.892 1.163-.133.494-.065 1.011.19 1.454.342.591.978.958 1.66.958.335 0 .667-.088.957-.256l6.673-3.852c.597-.347.964-.989.958-1.68M4.386 7.943l6.674 3.852c.778.452 1.738.304 2.352-.295.39-.358.63-.87.63-1.437V2.34c0-1.08-.874-1.955-1.951-1.955-1.08 0-1.955.875-1.955 1.955v4.395l-3.79-2.188c-.937-.542-2.136-.221-2.678.716-.543.938-.22 2.137.718 2.68M19.392 16.531c0 .148-.085.353-.19.46l-2.645 2.645c-.105.105-.313.19-.46.19h-.674c-.147 0-.355-.085-.46-.19l-2.648-2.645c-.105-.107-.19-.312-.19-.46v-.673c0-.15.085-.355.19-.46l2.648-2.648c.105-.105.313-.19.46-.19h.674c.147 0 .355.085.46.19l2.645 2.648c.105.105.19.31.19.46v.673zm-2.36-.324v-.028c0-.108-.063-.259-.14-.338l-.781-.778c-.077-.08-.227-.143-.338-.143h-.029c-.108 0-.258.063-.338.143l-.778.778c-.077.077-.14.227-.14.338v.028c0 .111.063.262.14.338l.778.782c.08.076.23.139.338.139h.029c.11 0 .261-.063.338-.14l.781-.78c.077-.077.14-.228.14-.339zM20.426 11.795L27.1 7.943c.938-.54 1.262-1.741.72-2.679-.543-.937-1.742-1.258-2.68-.716l-3.738 2.16V2.34c0-1.08-.875-1.955-1.952-1.955-1.08 0-1.955.875-1.955 1.955v7.568c-.037.392.04.801.253 1.17.543.938 1.742 1.26 2.68.716M12.398 20.398c-.443-.085-.918-.014-1.338.227L4.386 24.48c-.937.54-1.261 1.739-.718 2.676.542.94 1.741 1.262 2.679.719l3.79-2.188v4.361c0 1.077.874 1.952 1.954 1.952 1.077 0 1.952-.875 1.952-1.952v-7.721c0-.975-.713-1.782-1.645-1.93M31.27 11.352c-.54-.94-1.742-1.261-2.68-.718l-6.672 3.852c-.64.37-.992 1.045-.98 1.733-.006.684.346 1.352.98 1.716l6.673 3.855c.937.54 2.136.219 2.679-.719.543-.937.219-2.136-.719-2.679l-3.778-2.182 3.778-2.182c.94-.54 1.262-1.738.719-2.676"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'SnowflakeLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
